// KnowledgeRoboClickKnowledgeDto.js

class KnowledgeRoboClickKnowledgeDto {
    actionType = String();
    actionDetail = String();
    searchCondition = String();
    qaCategory = String();
    tagGroup = String();
    selectTag = String();

    actionDate = String();
    sessionId = String();
    destinationOrgId = String();
    destinationOrgDomain = String();
    destinationOrgName = String();
    destinationPrjId = String();
    destinationPrjName = String();
    orgActionId = String();
    orgActionDomain = String();
    orgActionName = String();
    prjActionId = String();
    prjActionName = String();
    userActionId = String();
    userActionEmail = String();
    userActionName = String();

    operationScreen = String();

    ticketId = String();
    ticketName = String();
    creatorId = String();
    creatorEmail = String();
    creatorName = String();
    formatId = String();
    formatName = String();

    constructor(data) {
        this.actionType = data.actionType;
        this.actionDetail = data.actionDetail;
        this.searchCondition = data.searchCondition;
        this.qaCategory = data.qaCategory;
        this.tagGroup = data.tagGroup;
        this.selectTag = data.selectTag;

        this.actionDate = data.actionDate;
        this.sessionId = data.sessionId;
        this.destinationOrgId = data.destinationOrgId;
        this.destinationOrgDomain = data.destinationOrgDomain;
        this.destinationOrgName = data.destinationOrgName;
        this.destinationPrjId = data.destinationPrjId;
        this.destinationPrjName = data.destinationPrjName;
        this.orgActionId = data.orgActionId;
        this.orgActionDomain = data.orgActionDomain;
        this.orgActionName = data.orgActionName;
        this.prjActionId = data.prjActionId;
        this.prjActionName = data.prjActionName;
        this.userActionId = data.userActionId;
        this.userActionEmail = data.userActionEmail;
        this.userActionName = data.userActionName;

        this.operationScreen = data.operationScreen;

        this.ticketId = data.ticketId;
        this.ticketName = data.ticketName;
        this.creatorId = data.creatorId;
        this.creatorEmail = data.creatorEmail;
        this.creatorName = data.creatorName;
        this.formatId = data.formatId;
        this.formatName = data.formatName;
    }
}

export default KnowledgeRoboClickKnowledgeDto;
